
<template>
  <div style="font-family: 'Roboto Slab', serif">
    <div v-if="Request == null || Request == '' || Request == undefined">
      <center class="loading-medium">
        <loading></loading>
      </center>
    </div>
    <div
      v-if="Request"
      style="
        width: 800px;
        height: 1000px;
        border: 1px solid black;
        margin: auto;
        padding: 20px;
        font-size: 14px;
      "
    >
      <div style>
        <div class="col-xs-2">
          <img
            src="../../assets/imgs/png/FAJRLOGO01.png"
            style="float: left; height: 90px; width: 130px"
          />
        </div>
        <div class="col-xs-8" style="text-align: center">
          <h3
            style="
              font-weight: 500;
              margin-top: 60px;
              font-size: 28px;
              font-family: 'Roboto Slab', serif;
            "
          >
            APPROVAL OF PAYMENT OBLIGATION TRANSFER
          </h3>
        </div>
        <div class="col-xs-2">
          <img
            src="../../assets/imgs/arabic-logo.jpg"
            style="float: right; height: 90px; width: 130px"
          />
        </div>
      </div>
      <br clear="all" />
      <!-- <h2
      style="text-align:center;padding-bottom:0;border-top:solid 1px #000;margin-bottom:2px;padding-bottom:5px;padding-top:5px;border-bottom:solid 1px #000;"
      >SELLER'S OFFER</h2>-->

      <!-- <div style="padding-top:0;margin-top:0;height:1px;border-top:solid 1px #000;margin-top:1px"></div> -->
      <hr style="border: 1.2px solid #b35900" />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">To:</div>
          <div class="col-xs-6">
            {{ Request.BankName }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">Date:</div>
          <div class="col-xs-6">
            {{ DateFromat(Request.ApplicationDate, true) }}
          </div>
        </div>
      </div>

      <hr style="border: 1px solid #b35900; margin-top: 5px" />

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="font-weight: bold">
            Subject: Approval of Payment Obligation Transfer
          </div>
        </div>
      </div>
      <br />
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            <p>
              <b>Fajr Investment Advisory</b>
              hereby accepts irrevocably this transfer notice of the payment
              obligation transfer and acknowledge that the Total Amount of
              <b
                >{{ Request.CurrencyShortname }}&nbsp;
                {{ Request.StringAmount }}
              </b>
              will be settled by Ashton Commodities Limited on
              <b>{{ DateFromat(Request.ValueDate, true) }}</b
              >. Therefore we exempt <b> {{ Request.BankName }}</b> from the
              Total Price of the commodity stated above and this shall be
              considered as a completely fulfilled settlement by
              <b> {{ Request.BankName }}</b>
              commitment.
              <br />
              <br />
              Our Signature below Acknowledges the terms stated above.
            </p>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12">
            <br />For and on behalf of
            <br />
            <b>Fajr Investment Advisory B.S.C.(c)</b>
            <br />
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <p style="text-align: center; font-size: 10px; margin-bottom: -15px">
        <em style="font-size: 16px"
          >This is a computer generated document, issued by a secure platform
          and as such, does not require a signature.</em
        >
      </p>
      <hr style="border: 1px solid #b35900" />
      <p style="font-size: 14px; text-align: center; margin-top: -30px">
        <br />P.O.Box 10797 - Manama,Kingdom of Bahrain, Tel: +973 17 540600,
        www.fajr.com.bh C.R.-68481
      </p>
    </div>
  </div>
</template>

<style scoped>
* {
  font-size: 18px;
}
</style>

  <script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapGetters({
      Request: "GETBUYREQUEST",
      AggrementDate: "GETAGGREMENTDATE",
    }),
  },
};
</script>
<style scopped>
tr td {
  border: 0;
}
.Details > tr > td:nth-child(odd) {
  width: 26%;
}
</style>
